<template>
  <div class="chart-container">
    <b-card class="job-card-status">
      <b-card-header>
        <b-card-title>Production Status</b-card-title>
      </b-card-header>
      <apexcharts 
        ref="chart" 
        height="350" 
        type="pie" 
        :options="chartOptions" 
        :series="chartData.series" 
        @dataPointSelection="selectBar"
      ></apexcharts>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "ProductionStatusChart",
  props: {
    statusData: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    apexcharts: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'pie',
        },
        labels: this.chartData.labels,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        plotOptions: {
          pie: {
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.globals.labels[opts.seriesIndex] + ': ' + val.toFixed(1) + '%';
          }
        },
        legend: {
          position: 'bottom'
        }
      };
    },
    chartData() {
      if (this.statusData && this.statusData.length > 0) {
        const labels = this.statusData.map(item => item.productionStatus);
        const series = this.statusData.map(item => item.quantity);
        
        return {
          labels: labels,
          series: series
        };
      }
      
      return {
        labels: ["No Data Available"],
        series: [0]
      };
    },
  },
  methods: {
    selectBar(event, chartContext, config) {
      const selectedIndex = config.dataPointIndex;
      const selectedStatus = this.chartData.labels[selectedIndex];
      console.log("Selected status:", selectedStatus);
      
      let statusParam;
      switch(selectedStatus) {
        case "FINISHED":
          statusParam = 2;
          break;
        case "PENDING":
          statusParam = 1; 
          break;
        case "NOT STARTED":
          statusParam = 0; 
          break;
        default:
          statusParam = -1;
      }
      
      if (statusParam >= 0) {
        this.$router.push({ name: "jobcard-list-status", params: {status: statusParam} });
      }
    },
  },
  watch: {
    statusData: {
      handler(newData) {
        console.log("Status data updated:", newData);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.job-card-status {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>